import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useForm} from "react-hook-form"
import {useTranslation} from "react-i18next"
import axios from "axios"
import {API_ME} from "../../constants/apiUrls"
import useUser from "../../swrCustomHooks/useUser"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import noEncryptionIcon from "../../assets/icon/no-encryption.svg"
import {toast} from "react-toastify"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function ProfileForm() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {user, mutateUser, isLoadingUser, isErrorUser} = useUser(sessionContext.idUser)
    const {register, handleSubmit, formState: {errors}} = useForm()

    const updateProfileRequest = (data) => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            if (data.firstname === "") {
                data.firstname = user.firstname
            }
            if (data.lastname === "") {
                data.lastname = user.lastname
            }
            axios.put(API_ME, data, headersRequest)
            .then(() => {
                mutateUser()
                window.location.reload()
                toast.success(t("Changes made"))
            })
            .catch((error) => {
                console.error("PUT /me: ", error)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (isErrorUser || isLoadingUser || user.message) return <LoadingComponent/>
    return (
        <>
        <form className="profile-form" onSubmit={handleSubmit(updateProfileRequest)}>
            <div className="field firstname">
                <label for="">{t("Firstname")}</label>
                <input type="text" id="firstname" name="firstname" placeholder={user.firstname} {...register("firstname", {pattern: /^[a-zA-Z0-9!@#$&()`.+,/"-\s\-_ ’'‘ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]{2,54}$/})}/>
            </div>
            <div className="field lastname">
                <label for="">{t("Lastname")}</label>
                <input type="text" id="lastname" name="lastname" placeholder={user.lastname} {...register("lastname", {pattern: /^[a-zA-Z0-9!@#$&()`.+,/"-\s\-_ ’'‘ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ]{2,54}$/})}/>
            </div>
            <div className="field mail">
                <label for="">Email</label>
                <input type="mail" placeholder={user.email} disabled/>
                <img src={noEncryptionIcon} alt=""/>
            </div>
            <button title={t("Update profile information")}>{t("Update")}</button>
        </form>
        </>
    )
}